import { render, staticRenderFns } from "./ManagePrivacy.vue?vue&type=template&id=ea20b482&scoped=true"
import script from "./ManagePrivacy.vue?vue&type=script&lang=ts"
export * from "./ManagePrivacy.vue?vue&type=script&lang=ts"
import style0 from "./ManagePrivacy.vue?vue&type=style&index=0&id=ea20b482&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea20b482",
  null
  
)

export default component.exports